<template>
  <transition name="toast-transition">
    <div
      v-if="toast.messages.length"
      class="fixed bottom-10 left-1/2 z-50 flex -translate-x-1/2 transform flex-col-reverse items-center gap-y-4"
    >
      <div
        v-for="message in toast.messages"
        :key="message.id"
        data-cy="toast-message"
        class="flex w-fit items-center rounded-sm sm:whitespace-nowrap"
        :style="{ backgroundColor: DEFAULT_BRANDING.colour }"
      >
        <div v-if="message.icon" class="pl-4" :data-cy="`toast-message-icon-${message.type}`">
          <component :is="message.icon" :class="messageTypeToClassName[message.type]" />
        </div>
        <div
          class="flex flex-col justify-center space-y-1 px-4 py-2 text-sm font-light"
          :style="{ color: DEFAULT_BRANDING.heading_font_colour }"
        >
          <span :class="{ 'font-semibold': !!message.subTitle }">
            {{ message.title }}
          </span>
          <span v-if="message.subTitle" data-cy="toast-message-subtitle" class="opacity-70">
            {{ message.subTitle }}
          </span>
        </div>
        <div
          v-if="message.canClose || message.action"
          class="relative flex items-center justify-center p-4"
        >
          <div
            class="absolute top-2 left-0 h-[calc(100%-1rem)] w-[0.5px] opacity-70"
            :style="{ backgroundColor: DEFAULT_BRANDING.heading_font_colour }"
          />
          <div class="flex items-center space-x-2">
            <button
              v-if="message.action"
              class="cursor-pointer text-sm font-semibold"
              :style="{ color: DEFAULT_BRANDING.heading_font_colour }"
              @click.prevent="message.action.handler()"
            >
              {{ message.action.label }}
            </button>
            <icon-clear
              v-if="message.canClose"
              data-cy="delete-toast-message"
              class="cursor-pointer opacity-70"
              :style="{ color: DEFAULT_BRANDING.heading_font_colour }"
              @click="message.destroy()"
            />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import IconClear from "@/components/icons/IconClear.vue";
import { DEFAULT_BRANDING } from "@/composables/state/brandingState";
import useToastState, { type ToastType } from "@/composables/state/toastState";

const toast = useToastState();

const messageTypeToClassName: Record<ToastType, string> = {
  success: "text-emerald-400",
  warning: "text-california-500",
  error: "text-red-400",
};
</script>

<style scoped>
@reference "@/tailwind.css";

.toast-transition-enter-active {
  transition: all 0.2s ease-out;
}

.toast-transition-leave-active {
  transition: all 0.2s ease-in;
}

.toast-transition-enter-from,
.toast-transition-leave-to {
  @apply translate-y-32 opacity-0;
}
</style>
